// extracted by mini-css-extract-plugin
export default {"item":"Timeline_item__63qOX","badge":"Timeline_badge__RjFM2"};